import styled from 'styled-components';
import Card from '$app/components/vendor/Card';
import { Input, Alert } from 'antd';
import ActionButton from '$app/apps/bookings/components/ActionButton';
import ActionProgressButton from '$app/apps/bookings/components/actionProgress/button';

const { TextArea } = Input;

export const StyledAlert = styled(Alert)`
  width: 560px;
  margin-bottom: 10px;
  padding: 8px 15px;

  display: flex;

  img {
    width: 17px;
    align-self: flex-start;
    margin: 2px 5px 0 0;
  }

  .highlight {
    color: #1082ea;
    font-weight: bold;
  }
`;

export const SendDraftFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 25px 0;
`;
export const NoteComponent = styled(TextArea)`
  width: 560px !important;
  height: 129px !important;
`;

export const WorkDetailsContainer = styled(Card)`
  margin-bottom: 0;
`;

export const StyledSubmitButton = styled(ActionProgressButton)`
  margin: 8px;

  &.light-disabled.ant-btn {
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
`;

export const StyledActionButton = styled(ActionButton)`
  display: inline-flex !important;
  padding: 0 !important;
  p {
    padding-top: 0 !important;
  }
  img {
    width: 20px;
  }
`;
